const s = 0, t = 10, n = ["m", "mt", "mr", "mb", "ml"], p = ["p", "pt", "pr", "pb", "pl"], i = [
  ...n,
  ...p
];
export {
  n as marginOptionsKeys,
  t as maxSpacingValue,
  s as minSpacingValue,
  p as paddingOptionsKeys,
  i as spacingOptionsKeys
};
//# sourceMappingURL=spacing.js.map
